<template>
  <div>
    <v-card color="" elevation="0" class="">
      <v-divider></v-divider>
      <template>
        <v-tabs color="primary" v-model="tabs" class="px-4" height="80" background-color="#f4f4f4">
          <div class="d-flex align-center">
            <v-icon color="primary " size="">mdi-bullhorn-variant-outline</v-icon>
            <h5 class="font-weight-bold headline ml-2">{{ $t('marketing.title') }}</h5>

          </div>
          <v-tab v-if="!$root.auth.profile.whitelabelId">{{ $t('marketing.promotions.title') }}</v-tab>
          <v-tab>SEO</v-tab>
          
          <v-tab disabled>Pesquisas<v-chip x-small class="ml-2" color="info"><span
            class="black---text">{{ $t('sales.clientsList.underDev') }}</span></v-chip></v-tab>
          <v-tab disabled>{{ $t('marketing.emailMkt.title') }}<v-chip x-small class="ml-2" color="info"><span
                class="black---text">{{ $t('sales.clientsList.underDev') }}</span></v-chip></v-tab>
          <v-tab disabled>{{ $t('marketing.messages.title') }}<v-chip x-small class="ml-2" color="info"><span
                class="black---text">{{ $t('sales.clientsList.underDev') }}</span></v-chip></v-tab>

        </v-tabs>
      </template>
      <v-tabs-items v-model="tabs">
        <v-tab-item v-if="!$root.auth.profile.whitelabelId">
          <PromotionsList></PromotionsList>
        </v-tab-item>
        <v-tab-item>
          <SEO></SEO>
        </v-tab-item>
        <v-tab-item>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <!-- </template>
      </v-col>

    </v-row>-->
  </div>
</template>

<script>
// import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";

import PromotionsList from '@/components/marketing/PromotionsList.vue';
import SEO from '@/components/marketing/SEO.vue'
export default {
  name: "MktTable",
  components: { PromotionsList, SEO },
  data() {
    return {
      tabs: 0,

    };
  },
  mounted() {
    this.loadTabs()
  },
  watch: {
    '$route.params.tab'() {
      this.loadTabs()
    },
    'tabs'(nV) {
      let query = []
      for (let key in this.$route.query) {
        // if(nV != 0 && key == 'q')
        query.push(`${key}=${this.$route.query[key]}`)
      }
      const qstring = query.length ? `?${query.join('&')}` : ''

      if (nV == 0 && this.$route.path != '/marketing/promotions')
        this.$router.replace(`/marketing-and-seo/promotions${qstring}`)
    }
  },
  methods: {
    loadTabs() {
      if (!this.$route.params.tab) {
        this.tabs = 0
      }
      else {
        if (this.$route.params.tab == 'promotions') {
          this.tabs = 0
        }

      }
    }
  },
}
</script>

<style lang="scss" scoped></style>